export function getPreferredCompsSection() {
  try {
    const validSection = ["comps", "map", "stats", "list", "valuate"];
    let section = window.localStorage.getItem("preferred-comps-section");
    if (!validSection.includes(section)) section = "comps";
    return section;
  } catch (error) {
    console.warn("Could not get the preferred comps section.");
    return "comps";
  }
}

export function setPreferredCompsSection(section) {
  try {
    window.localStorage.setItem("preferred-comps-section", section);
  } catch (error) {
    console.warn("Could not set preferred comps section.");
  }
}
